import script from "./Record1ChSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./Record1ChSetting.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__